import { render, staticRenderFns } from "./AddCardPage.vue?vue&type=template&id=711631ba&scoped=true&"
import script from "./AddCardPage.vue?vue&type=script&lang=js&"
export * from "./AddCardPage.vue?vue&type=script&lang=js&"
import style0 from "./AddCardPage.vue?vue&type=style&index=0&id=711631ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711631ba",
  null
  
)

export default component.exports